import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import { E_ZIndexes } from '@/helpers/consts'


export const SC_HeaderWrapper = styled.div`
  width: 100%;
  border-radius: 16px;
  padding: 16px;
  position: relative;
  background-color: ${E_Colors.White};
  z-index: ${E_ZIndexes.Level2};
`

export const SC_Title = styled.h3`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 500;
`
